"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorCodes = exports.AccessorStatus = exports.AccessorRole = exports.SERVICE_NAME = void 0;
exports.SERVICE_NAME = 'class-service';
var AccessorRole;
(function (AccessorRole) {
    AccessorRole["owner"] = "OWNER";
    AccessorRole["editor"] = "EDITOR";
    AccessorRole["enrolee"] = "ENROLEE";
})(AccessorRole = exports.AccessorRole || (exports.AccessorRole = {}));
var AccessorStatus;
(function (AccessorStatus) {
    AccessorStatus["active"] = "ACTIVE";
    AccessorStatus["pending"] = "PENDING";
})(AccessorStatus = exports.AccessorStatus || (exports.AccessorStatus = {}));
exports.errorCodes = Object.freeze({
    FORBIDDEN_FOR_MANAGED_CLASS: 'FORBIDDEN_FOR_MANAGED_CLASS',
    MAX_COURSES_FOR_CLASS_REACHED: 'MAX_COURSES_FOR_CLASS_REACHED',
    MAX_ACTIVE_CLASSES_REACHED: 'MAX_ACTIVE_CLASSES_REACHED'
});
//# sourceMappingURL=index.js.map